import React from 'react';
import type { SessionBadge } from './dataTransformations';

/** A small pill naming a session's state, such as Archived. */
const SessionBadgeComponent: React.FC<SessionBadge> = ({ label, background, color }) => (
  <span
    style={{
      flexShrink: 0,
      fontSize: '11px',
      backgroundColor: background,
      color,
      padding: '2px 8px',
      borderRadius: '10px',
      fontWeight: 600,
    }}
  >
    {label}
  </span>
);

export default SessionBadgeComponent;
